import memoizeOne from "memoize-one";
import * as PropTypes from "prop-types";
import * as React from "react";
import { Modal } from "react-bootstrap";
import { MutexWrapper } from "../util/MutexContext";
class MyModal extends React.PureComponent {
    static Header = Modal.Header;
    static Title = Modal.Title;
    static Body = Modal.Body;
    static Footer = Modal.Footer;
    static childContextTypes = {
        menuLayer: PropTypes.object,
    };
    getContainer = memoizeOne(() => this.getContainerImpl());
    mMenuLayer = null;
    getChildContext() {
        return { ...this.context, menuLayer: this.mMenuLayer };
    }
    render() {
        return (React.createElement("div", { className: "modal-container" },
            React.createElement(MutexWrapper, { show: this.props.show },
                React.createElement(Modal, { ...this.props, container: this.getContainer() },
                    React.createElement("div", { className: "menu-layer", ref: this.setMenuLayer }),
                    this.mMenuLayer !== null ? this.props.children : null))));
    }
    getContainerImpl() {
        return document.getElementById("overlays");
    }
    setMenuLayer = (ref) => {
        this.mMenuLayer = ref;
        this.forceUpdate();
    };
}
export default MyModal;
